import { config } from 'config/config';
import { serialize } from 'cookie';
import cookie from 'js-cookie';
import getConfig from 'next/config';

const { PLATFORM_PREFIX } = getConfig().publicRuntimeConfig;

const { ACCESS_TOKEN, BASE_COOKIE_DOMAIN, REFRESH_TOKEN } = config.COOKIES;

const UNSET_COOKIE_PLACEHOLDER = {
  expires: null,
  path: PLATFORM_PREFIX,
  domain: BASE_COOKIE_DOMAIN,
};

export const setCookieFromClient = (
  key: string,
  value: any,
  expires = 5,
  rememberMe?: boolean,
  customPath?: string,
) => {
  if (typeof window !== 'undefined') {
    cookie.set(key, value, {
      expires: rememberMe === false ? null : expires,
      path: customPath ?? PLATFORM_PREFIX,
      domain: BASE_COOKIE_DOMAIN,
    });
  }
};

export const getCookie = (key: string, req?: any) => {
  return typeof window !== 'undefined'
    ? getCookiesFromClient(key)
    : getCookiesFromServer(key, req);
};

export const getCookiesFromClient = (key: string) => {
  return cookie.get(key);
};

const getCookiesFromServer = (key: string, req: any) => {
  if (!req.headers.cookie) {
    return undefined;
  }
  const rawCookie = req.headers.cookie
    .split(';')
    .find((c) => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return undefined;
  }
  return rawCookie.split('=')[1];
};

export const removeCookieFromClient = (key: string) => {
  if (typeof window !== 'undefined') {
    cookie.remove(key, {
      ...UNSET_COOKIE_PLACEHOLDER,
    });
  }
};

export const removeCookiesFromServer = (key: string, ctx: any) => {
  ctx.res.setHeader('Set-Cookie', [
    serialize(key, '', {
      ...UNSET_COOKIE_PLACEHOLDER,
    }),
  ]);
};

export const removeAuthCookiesFromServer = (ctx: any) => {
  ctx.res.setHeader('Set-Cookie', [
    serialize(ACCESS_TOKEN, '', {
      ...UNSET_COOKIE_PLACEHOLDER,
    }),
    serialize(REFRESH_TOKEN, '', {
      ...UNSET_COOKIE_PLACEHOLDER,
    }),
  ]);
};
